export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Singing (Opera, Bollywood, Hindustani, Western Contemporary).</li>
                                <li>Instruments (Guitar, Piano, Violin).</li>
                                <li>Music Theory & Production.</li>
                                <li>Stage performance, ensemble work, and studio experience.</li>
                                <li>Personalized roadmap covering all disciplines.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Aspiring professional musicians seeking 360° training.</li>
                                <li>Performers aiming for global careers.</li>
                                <li>Students exploring versatility across instruments and vocals.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Mastery across multiple disciplines.</li>
                                <li>Stage and studio readiness with professional confidence.</li>
                                <li>International certification eligibility.</li>
                                <li>Complete preparation for a career in global music industry.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 